<template>
  <div class="page">
    <div class="error">
      <div class="error__wrapper" v-if="type === 'login_error'">
        <img
          src="../assets/img/crying.png"
          alt="Произошла ошибка входа!"
          class="error__img"
        />
        <h1 class="error__title">Произошла ошибка входа!</h1>
        <p class="error__description">
          Попробуйте снова или обратитесь <br />
          в техническую поддержку.
        </p>
        <div class="error__buttons">
          <button
            class="pBtn pBtn--grey error__button"
            @click="$router.push('/support')"
          >
            Поддержка
          </button>
          <button
            class="pBtn pBtn--blue error__button"
            @click="$router.push('/login')"
          >
            Повторить вход
          </button>
        </div>
      </div>
      <div class="error__wrapper" v-if="type === 'auth_error'">
        <img
          src="../assets/img/thinking.png"
          alt="Похоже, что у вас нет доступа"
          class="error__img"
        />
        <h1 class="error__title">Похоже, что у вас нет доступа</h1>
        <p class="error__description">
          К сожалению, не удается войти в сервис. Возможно, у вас нет доступа.
          Узнать, как его получить, можно, связавшись с контактным центром.
        </p>
        <div class="error__buttons">
          <button
            class="pBtn pBtn--blue error__button"
            @click="$router.push('/support')"
          >
            Связаться
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotAllowedError",
  props: ["type"]
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
@import "@/assets/scss/global.scss";

.page {
  background: $new-blue;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  @media #{$tablet} {
    padding: 0;
  }
}

.error {
  background: #ffffff;
  border-radius: 10px;
  padding: 90px 0;
  display: flex;
  justify-content: center;
  max-width: 1200px;
  width: 100%;
  text-align: center;
  @media #{$tablet} {
    min-height: 100vh;
    border-radius: 0;
    padding: 150px 0;
  }
  @media #{$mobile} {
    padding: 45px 15px;
  }

  &__wrapper {
    @media #{$tablet} {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
    }
  }

  &__img {
    margin-bottom: 30px;
    max-width: 120px;
    @media #{$tablet} {
      margin: 0;
    }
    @media #{$mobile} {
      max-width: 100px;
    }
  }

  &__title {
    padding: 0;
    margin: 0 0 60px;
    font-weight: bold;
    font-size: 48px;
    @media #{$tablet} {
      margin: 0;
      max-width: 500px;
    }
    @media #{$mobile} {
      font-size: 34px;
    }
  }

  &__description {
    font-size: 21px;
    margin: 0 auto 140px;
    max-width: 560px;
    @media #{$tablet} {
      margin: 0;
    }
    @media #{$mobile} {
      font-size: 17px;
    }
  }

  &__buttons {
    & > * {
      margin: 0 15px;
      @media #{$mobile} {
        margin: 8px 0;
        width: 100%;
      }
    }
  }
}
</style>
